import _ from 'lodash';

/**
 * Converts a URL to its primary domain, excluding subdomains.
 *
 * Assumes a 1-part top-level domain such as .gov. This would not work for TLD like co.uk
 */
export default function urlToPrimaryDomain(url) {
  try {
    const urlObject = new URL(url);
    const domainParts = urlObject.hostname.split('.');

    return _.takeRight(domainParts, 2).join('.');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Invalid URL', url);
    return url;
  }
}
